'use-strict';

import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';
import Photoswipe from './photoswipe.esm.min.js';
// js gallery
class ZoomAction extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type || 'no_zoom';
    this.zoomOption = this.dataset.zoomOption || 'external';
    this.lightbox = null;
    this.lightboxBound = false;
    this.drift = null;
    this.init();
  }
  init() {
    if (this.type === 'no_zoom') return;
    window.addEventListener('resize', this.responsive.bind(this));
    window.addEventListener('load', this.responsive.bind(this));

    /* O <a> da galeria aponta para o arquivo original no CDN, e quem cancela
       essa navegacao e o handler de initLightBox(). Só que initLightBox() so
       era alcancado por responsive(), que roda no 'load' da janela — e 'load'
       espera TODAS as imagens da PDP carregarem. Entre o upgrade deste
       elemento e o 'load' havia uma janela sem handler nenhum: clicar ali
       seguia o href e baixava o arquivo.

       Vincular aqui fecha essa janela. Vale so para 'open_lightbox' porque e
       o unico modo em que o <a> recebe href (ver product-media-layout.liquid);
       nos outros modos o anchor nao navega. A delegacao nao depende de os
       filhos ja existirem, entao chamar cedo e seguro. */
    if (this.type === 'open_lightbox') this.initLightBox();
  }
  initLightBox() {
    /* Delegacao no container, em vez de um listener por <a>. Dois motivos:

       1) Os anchors da galeria sao recriados quando a variante muda. Os novos
          ficavam sem handler, e como cada <a> tem href para o arquivo original
          no CDN, o clique nao interceptado navegava para a imagem — que e o
          "baixar/salvar o arquivo" que aparecia no duplo clique.

       2) responsive() chama este metodo a cada resize e a cada load, mas o
          guard antigo (this.lightbox !== null) so passa a valer DEPOIS do
          primeiro clique, porque e no clique que o lightbox e criado. Ate la,
          cada resize empilhava mais um listener no mesmo <a> — e um clique
          disparava varios PhotoSwipe de uma vez.

       O href fica: o PhotoSwipe le dele a imagem em tamanho grande. */
    if (this.lightboxBound) return;
    this.lightboxBound = true;
    this.addEventListener('click', (e) => {
      const target = e.target.closest('a.media-gallery__image');
      if (!target) return;
      var position = 0;
      e.preventDefault();
        if (target.getAttribute('data-position')) {
          position = target.getAttribute('data-position');
        } else if (
          target.closest('media-gallery').querySelector('.swiper-slide-active')
        ) {
          position = target
            .closest('media-gallery')
            .querySelector('.swiper-slide-active')
            .getAttribute('data-position');
        } else if (target.closest('media-gallery').firstChild) {
          position = target
            .closest('media-gallery')
            .firstChild?.getAttribute('data-position');
        }
        this.lightbox = new PhotoSwipeLightbox({
          gallery: this,
          children: 'a',
          pswpModule: () => Photoswipe,
          counter: false,
          zoom: false,
          preloader: false,
          arrowPrev: false,
          arrowNext: false,
          close: false,
          loop: false,
          bgOpacity: 1,
          /* Espaco reservado nas bordas. Sem isto o PhotoSwipe usa a tela
             inteira e a foto passa POR BAIXO das setas e das miniaturas.
             Aqui ela encolhe para caber entre elas.                        */
          paddingFn: (viewportSize) => {
            const estreito = viewportSize.x < 750;
            return {
              top: estreito ? 58 : 44,
              bottom: estreito ? 98 : 122,
              left: estreito ? 10 : 76,
              right: estreito ? 10 : 76,
            };
          },
        });
        this.lightbox.on('uiRegister', () => {
          const { pswp } = this.lightbox;
          pswp?.ui.registerElement({
            name: 'bls--close',
            isButton: true,
            tagName: 'button',
            html: '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="transition"><use href="#icon-close"></use></svg>',
            onClick: () => {
              pswp.close();
            },
          });
          /* --- setas junto da imagem ------------------------------------
             Antes elas viviam na pilula de baixo, junto do contador. Aqui
             ficam na altura do meio da foto: a mao ja esta olhando para a
             imagem, nao para o rodape da tela.                            */
          pswp?.ui.registerElement({
            name: 'ps-arrows',
            className: 'pswp__ps-arrows',
            appendTo: 'wrapper',
            onInit: (el, pswp) => {
              if (pswp.getNumItems() < 2) {
                el.style.display = 'none';
                return;
              }
              const criar = (dir, icone, rotulo) => {
                const b = document.createElement('button');
                b.type = 'button';
                b.className = 'pswp__ps-arrow pswp__ps-arrow--' + dir;
                b.setAttribute('aria-label', rotulo);
                b.innerHTML =
                  '<svg width="7" height="12" fill="none" aria-hidden="true"><use href="#' +
                  icone +
                  '"></use></svg>';
                b.onclick = () => (dir === 'prev' ? pswp.prev() : pswp.next());
                return b;
              };
              const prev = criar('prev', 'icon-back', 'Imagem anterior');
              const next = criar('next', 'icon-next', 'Proxima imagem');
              el.appendChild(prev);
              el.appendChild(next);

              /* a largura acompanha a foto exibida: em imagem estreita as
                 setas chegam perto dela, em vez de ficarem coladas na borda
                 da tela como se fossem de outro elemento                   */
              const ajustar = () => {
                const slide = pswp.currSlide;
                if (!slide || !slide.width) return;
                const largura = slide.width * (slide.currZoomLevel || 1);
                const alvo = Math.min(window.innerWidth - 20, largura + 132);
                el.style.width = Math.max(alvo, 260) + 'px';
              };

              /* sem loop nesta galeria: nas pontas o botao fica desativado
                 em vez de virar um clique que nao faz nada               */
              const estado = () => {
                prev.disabled = pswp.currIndex === 0;
                next.disabled = pswp.currIndex === pswp.getNumItems() - 1;
              };

              const atualizar = () => {
                ajustar();
                estado();
              };
              pswp.on('change', atualizar);
              pswp.on('resize', ajustar);
              pswp.on('zoomPanUpdate', ajustar);
              atualizar();
            },
          });

          /* --- miniaturas no lugar do contador --------------------------
             "3/8" diz quantas faltam; a miniatura diz o que vem. Clicar
             pula direto, e as setas andam de uma para a outra.            */
          pswp?.ui.registerElement({
            name: 'ps-thumbs',
            className: 'pswp__ps-thumbs',
            appendTo: 'wrapper',
            onInit: (el, pswp) => {
              const total = pswp.getNumItems();
              if (total < 2) {
                el.style.display = 'none';
                return;
              }
              const botoes = [];
              for (let i = 0; i < total; i++) {
                const dados = pswp.getItemData(i) || {};
                /* msrc e a miniatura que o PhotoSwipe ja carregou para a
                   animacao de abertura: reusar evita baixar a imagem
                   grande de novo so para preencher a fita                 */
                const src = dados.msrc || dados.src;
                const b = document.createElement('button');
                b.type = 'button';
                b.className = 'pswp__ps-thumb';
                b.setAttribute('aria-label', 'Ver imagem ' + (i + 1) + ' de ' + total);
                if (src) {
                  const img = document.createElement('img');
                  img.src = src;
                  img.alt = '';
                  img.loading = 'lazy';
                  img.draggable = false;
                  b.appendChild(img);
                }
                b.onclick = () => pswp.goTo(i);
                el.appendChild(b);
                botoes.push(b);
              }
              const marcar = () => {
                botoes.forEach((b, i) => {
                  const ativo = i === pswp.currIndex;
                  b.classList.toggle('is-active', ativo);
                  b.setAttribute('aria-current', ativo ? 'true' : 'false');
                });
                /* scrollTo no proprio container (e nao scrollIntoView, que
                   mexeria tambem na rolagem da pagina atras do lightbox) */
                const atual = botoes[pswp.currIndex];
                if (atual && el.scrollWidth > el.clientWidth) {
                  el.scrollTo({
                    left: atual.offsetLeft - (el.clientWidth - atual.offsetWidth) / 2,
                    behavior: 'smooth',
                  });
                }
              };
              pswp.on('change', marcar);
              marcar();
            },
          });
        });
        this.lightbox.init();
        this.lightbox.loadAndOpen(position-1);
    });
  }
   initDrift() {
    if (this.drift !== null) return;
    var allTriggers = this.querySelectorAll('.drift-trigger');
    var paneContainer = this.closest('.sec__featured-product').querySelector(
      '.zoom-external-area'
    );
    if (allTriggers.length != 0) {
      allTriggers.forEach( (trigger) => {
        const inlineContainer = trigger.closest('[data-pane-container]');
        const zoomOption = this.zoomOption;
        if (zoomOption === 'inner-2') {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption === 'inner-2',
            zoomFactor: 3,
            containInline: paneContainer,
            paneContainer: inlineContainer,
            hoverBoundingBox: zoomOption === 'external',
            onShow: function () {
              inlineContainer.classList.add('relative');
            },
            onHide: function () {
              inlineContainer.classList.remove('relative');
            },
          });
        } else {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption,
            zoomFactor: 5,
            containInline: !!paneContainer,
            paneContainer:
              zoomOption === 'external' ? paneContainer : inlineContainer,
            hoverBoundingBox: zoomOption === 'external',
            onShow: function () {
              inlineContainer.classList.add('relative');
            },
            onHide: function () {
              inlineContainer.classList.remove('relative');
            },
          });
        }
      });
    }
  }
  responsive() {
    if (window.innerWidth >= 768) {
      if (this.type === 'open_lightbox') {
        this.initLightBox();
      } else {
        if (this.lightbox !== null) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
        this.initDrift();
      }
    } else {
      if (this.type !== 'open_lightbox') {
        if (this.drift !== null) {
          this.drift.destroy();
          this.drift == null;
        }
        this.initLightBox();
      } else {
        this.initLightBox();
      }
    }
    this.updateSwiper();
  }

  updateSwiper() {
    if (typeof Swiper !== 'undefined') {
      if (this.querySelector('.thumbnail-slide')) {
        this.querySelector('.thumbnail-slide').swiper.update();
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.responsive.bind(this));
    window.removeEventListener('load', this.responsive.bind(this));
  }
}
customElements.define('zoom-action', ZoomAction);
